{
  "AdmittedBusinesses": "Tatt opp i inkubasjonsprogrammet i løpet av året",
  "AdvicedAccessToOtherTools": "Har dere bistått bedriften i prosesser med å få tilgang til andre virkemidler i år?",
  "BusinessDigitalCompetence": "Deltar i kompetansehevende tiltak innenfor digitalisering",
  "BusinessesAdvicedFromOthers": "Mottar rådgivning fra andre programoperatører",
  "BusinessesInOtherPrograms": "Tatt opp i program hos andre programoperatører",
  "BusinessesReferredToOthers": "Henvist til andre programoperatører",
  "CompetenceProjectsWithOthers": "Gjennomført nettverksprosjekt sammen med andre programoperatører",
  "CooperatingBusinesses": "",
  "DigitalCompetenceEmployees": "Ansatte har deltatt på kompetansehevende tiltak innenfor digitalisering",
  "DigitalizationInBusinessPlan": "Har digitalisering som et sentralt element i forretningsmodellen",
  "ExportCompetenceBuilding": "Tilbyr kompetansehevende tiltak innenfor eksport",
  "ExportTurnover": "Består hele eller deler av omsetningen av eksport?",
  "FemaleLeadership": "Har bedriften kvinnelig gründer og/eller kvinnelig daglig leder og/eller kvinnelig styreleder?",
  "InternationalCooperation": "Har bedriften blitt koblet opp mot internasjonal aktør?",
  "InternationalMarket": "Har bedriften internasjonalt marked?",
  "NewBusinesses": "Nyetablert",
  "NewIdeas": "Har ny idé",
  "OtherBusinessesAdviced": "Mottar rådgivning",
  "PaidEquity": "Egenkapital som er innbetalt til bedriften i løpet av året (oppgis i absolutte tall)",
  "SRLScaleIncrease": "Hvilket nivå i SRL-skalaen plasseres bedriften på?",
  "SupportedBusinesses": "Innovasjonsstøtte",
  "SustainabilityBusinesses": "Mottar kompetansehevende tiltak innenfor bærekraft",
  "SustainabilityEmployees": "Kompetansehevende tiltak innenfor bærekraft som ansatte i inkubatoren/næringshagen har deltatt på i løpet av året",
  "SustainabilityInBusinessModel": "Har bærekraft som et sentralt element i sin forretningsmodell",
  "TaxonomyQuestions": "Har bedriften (potensiell) vesentlig positiv eller negativ effekt på noen av miljømålene?"
}
